import React, { useEffect, useState } from 'react';
import {
    DataGrid, GridToolbarContainer, gridPageCountSelector,
    gridPageSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';
import { localDatabaseUrls } from '../../backend/constants';
//import { GridFilterInputValue } from '@mui/x-data-grid';
//import { COST_TYPE_OPTIONS } from "../../templates/CostUpload/CostUploadConstants";
import { svcDownloadFile } from '../../API/svcDownloadFile.Api';
import classess from '../../templates/CostUpload/CostUpload.module.css';
////import { Button,Tooltip,TextField,FormControl,Select,MenuItem } from "@mui/material";
//import { Button, Tooltip, TextField } from "@mui/material";
import { Button, Tooltip, TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';



const CostUploadHistory = ({ uploadHistory, isPaginationRequired }) => {

    const [gridData, setGridData] = useState(uploadHistory);
    const [loading, setLoading] = useState(true);
    useEffect(() => {


        // let uploadHistory = [
        //     {
        //         "id": 1,
        //         "fileName": "CJW_Cost_July2025.xlsx",
        //         "uploadedBy": "TestUser",
        //         "uploadedDate": "2025-07-14",
        //         "category": "Approved",
        //         "costType": "ASG",
        //         "status": "Uploaded",
        //         "supplier": "ABC Suppliers Ltd.",
        //         "tariff": 1200.50,
        //         "nonTariff": 250.00,
        //         "rows": "1/2",
        //         "downloadUrl": "/downloads/CJW_Cost_July2025.xlsx"
        //     },
        //     {
        //         "id": 2,
        //         "fileName": "CJW_Cost_June2025.xlsx",
        //         "uploadedBy": "JohnDoe",
        //         "uploadedDate": "2025-06-15",
        //         "category": "Approved",
        //         "costType": "ASG",
        //         "status": "Processed",
        //         "supplier": "XYZ Traders",
        //         "tariff": 975.75,
        //         "nonTariff": 310.25,
        //         "rows": "1/1",
        //         "downloadUrl": "/downloads/CJW_Cost_June2025.xlsx"
        //     },
        //     {
        //         "id": 3,
        //         "fileName": "CJW_Cost_May2025.xlsx",
        //         "uploadedBy": "AdminUser",
        //         "uploadedDate": "2025-05-20",
        //         "category": "Approved",
        //         "costType": "APG",
        //         "status": "Error",
        //         "supplier": "MegaCorp Inc.",
        //         "tariff": 0,
        //         "nonTariff": 0,
        //         "rows": "0/1",
        //         "downloadUrl": "/downloads/CJW_Cost_May2025.xlsx"
        //     }
        // ];

      if (uploadHistory && uploadHistory.length > 0) {
            uploadHistory.map((item) => {
                item.download = item.status === errorStatus ? 'y' : 'n'
                return item.uploadedDate
            })
            setGridData(uploadHistory);
            setLoading(false);
        }else{
             setLoading(false);
        }
    }, [uploadHistory])


    const errorStatus = "Processed with errors";
    const originalStatus = ["Uploaded", "In progress"];
    const handleReset = () => {
        window.location.reload();
    }
    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>
                <Button variant="contained" style={{ marginLeft: 'auto', backgroundColor: 'darkblue' }} onClick={handleReset}>Reset</Button>
            </GridToolbarContainer>
        )
    }

    // function getCategoryLabel(category) {
    //     return COST_TYPE_OPTIONS.find(
    //         option => option.value === category?.toLowerCase()
    //     )?.label ?? "";
    // }

    function rowProcess(validRows, totalRows) {
        return totalRows !== null && validRows !== null ? validRows + '/' + totalRows : '0/0';

    }
    function CustomPagination() {
        const apiRef = useGridApiContext();
        const page = useGridSelector(apiRef, gridPageSelector);
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);

        return (
            isPaginationRequired ? <Pagination
                color="primary"
                count={pageCount}
                page={page + 1}
                onChange={(event, value) => apiRef.current.setPage(value - 1)}
            /> : null
        );
    }

    const handleDownload = async (fileId, fileName, downloadFile) => {
        try {
            await svcDownloadFile(fileId, fileName, downloadFile);

        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    };

    useEffect(() => {

        

    }, [])
    const CustomDateFilterInput = (props) => {
        const { item, applyValue } = props;
        const [selectedDate, setSelectedDate] = useState(item.value ? new Date(item.value) : null);

        const handleChange = (newDate) => {
            const formattedDate = newDate ? format(newDate, 'yyyy-MM-dd') : null;
            setSelectedDate(newDate);
            applyValue({ ...item, value: formattedDate });
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    label="Select Date"
                    value={selectedDate}
                    onChange={(newDate) => handleChange(newDate)}
                    views={['year', 'month', 'day']}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                />
            </LocalizationProvider>
        );
    };
    const columns =
        [
            // {
            //     field: 'fileName', flex: 1, headerName: 'File Name-2', sortable: true, filterable: true, width: 200,
            //     renderCell: (params) => {
            //         return (originalStatus.includes(params.row.status) ?
            //             params.row.fileName :
            //             (<Tooltip title={params.row.fileName}>
            //                 <Button style={{ overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '150px', textOverflow: 'ellipsis', display: 'inline-block' }}
            //                     onClick={() => handleDownload(params.row.id, params.row.fileName, localDatabaseUrls.serviceURL.originalFilePrefix)}>
            //                     {params.row.fileName}
            //                 </Button>
            //             </Tooltip>
            //             )
            //         )

            //     },
            // },
            {
                field: 'fileName',
                headerName: 'File Name',
                flex: 1,
                sortable: true,
                filterable: true,
                width: 200,
                valueGetter: (params) => params.row.fileName, // ensures filtering uses the fileName value
                renderCell: (params) => {
                    return (
                        originalStatus.includes(params.row.status)
                            ? params.row.fileName
                            : (
                                <Tooltip title={params.row.fileName}>
                                    <Button
                                        style={{
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            maxWidth: '150px',
                                            textOverflow: 'ellipsis',
                                            display: 'inline-block'
                                        }}
                                        onClick={() =>
                                            handleDownload(
                                                params.row.uuid,
                                                params.row.fileName,
                                                localDatabaseUrls.serviceURL.originalFilePrefixSvc
                                            )
                                        }
                                    >
                                        {params.row.fileName}
                                    </Button>
                                </Tooltip>
                            )
                    );
                }
            },
            {
                field: 'uploadedBy',
                flex: 1,
                headerName: 'Uploaded By',
                sortable: true,
                filterable: true,
                width: 200,
            },
            {
                field: 'uploadedDate', flex: 1, headerName: 'Uploaded Date', sortable: true, filterable: true, width: 200,


                filterOperators: [
                    {
                        label: 'is',
                        value: 'is',
                        getApplyFilterFn: (filterItem) => {
                            if (!filterItem.columnField || !filterItem.value) {
                                return null;
                            }
                            const filterDate = new Date(filterItem.value);
                            return ({ value }) => {
                                const cellDate = new Date(value);
                                return (cellDate.getFullYear() === filterDate.getFullYear() && cellDate.getMonth() ===
                                    filterDate.getMonth() && cellDate.getDate() === filterDate.getDate())
                            }
                        },
                        InputComponent: CustomDateFilterInput
                    },

                    {
                        label: 'is after',
                        value: 'is after',
                        getApplyFilterFn: (filterItem) => {
                            if (!filterItem.columnField || !filterItem.value) {
                                return null;
                            }
                            return ({ value }) => new Date(value) > new Date(filterItem.value);
                        },
                        InputComponent: CustomDateFilterInput
                    },
                    {
                        label: 'is before',
                        value: 'is before',
                        getApplyFilterFn: (filterItem) => {
                            if (!filterItem.columnField || !filterItem.value) {
                                return null;
                            }
                            return ({ value }) => new Date(value) < new Date(filterItem.value);
                        },
                        InputComponent: CustomDateFilterInput
                    }
                ]
            },
            {
                field: 'costType', flex: 1, headerName: 'APG/ASG', sortable: true, filterable: true, width: 200,
            },
             
            {
                field: 'status', flex: 1, headerName: 'Status', sortable: true, filterable: true, width: 200,
            },
            {
                field: 'rows', flex: 1, headerName: 'Rows (Valid/Total)', sortable: true, filterable: true, width: 100,
                valueGetter: (params) => rowProcess(params.row.validRows, params.row.totalRows),
            },
            {
                field: 'download', flex: 1, headerName: 'Download report', sortable: true,
                disableColumnMenu: true, width: 200,
                renderCell: (params) => (
                    params.row.status === errorStatus && (
                        <Button className={classess.uploadBtn}
                            onClick={() => handleDownload(params.row.uuid, params.row.fileName, localDatabaseUrls.serviceURL.errorFileSvc)}>
                            Download
                        </Button>
                    )
                ),

            }
        ]
     return (
                <div style={{ height: 'calc(100vh - 200px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ flex: 1, overflow: 'auto' }}>
                        <DataGrid
                            components={{
                                Toolbar: CustomToolbar,
                                Pagination: CustomPagination, 
                            }}
                            rows={gridData }
                             getRowId={(row) => row.uuid}
                            columns={columns}
                            disableRowSelectionOnClick
                            pagination
                            pageSize={10}
                            autoHeight={false}
                             loading={loading}
                            sortingMode="client"
                            filterMode="client"
                            sx={{
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 'bold',
                                },
                                '& .MuiDataGrid-toolbarcontainer': {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                },
                                '& .MuiDataGrid-cellContent': {
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                },
                            }}
                        />
                    </div>
                </div>
            );
}

export default CostUploadHistory;